import fr from 'facet-rest';
import MultiselectField from 'Components/ComponentLibrary/Components/Uncategorized/MultiselectField';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';

export default fr
  .metaOverride({ base: BaseOverride })
  .typeOverride('multipicklist', {
    _component: () => MultiselectField,
  });
